export { default } from './secondary-availability';
